const routerUrls = {
  HOME: { path: '/home', title: '' },
  DASHBOARD: { path: '/dashboard', title: '' },
  MY_BENEFITS: { path: '/mybenefits', title: '' },
  MY_PROFILE: { path: '/myprofile', title: '' },
  MY_NOTICES: { path: '/mynotices', title: '' },
  MY_DOCUMENTS: { path: '/mydocuments', title: '' },
  MY_ACCOUNTS: { path: '/myaccounts', title: '' },
  FEEDBACK: { path: '/feedback', title: '' },
  FEEDBACK_LANDING: { path: '/feedBackLanding', title: '' },
  LOGIN: { path: '/login', title: '' },
  LANDING: { path: '/landing', title: '' },
  USER_ACCESS: { path: '/useraccess', title: '' },
  MANAGE_BANNERS: { path: '/banners', title: '' },
  UTILITIES: { path: '/utilityoptout', title: '' }
}
export default routerUrls
